import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FeatureTreeState {
  isFeatureTreeBeingEdited: boolean;
  isFeatureTreeBeingSelected: boolean;
}

const initialState: FeatureTreeState = {
  isFeatureTreeBeingEdited: false,
  isFeatureTreeBeingSelected: false,
};

const featureTreeSlice = createSlice({
  name: 'featureTree',
  initialState,
  reducers: {
    setIsFeatureTreeBeingEdited: (state, action: PayloadAction<boolean>) => {
      state.isFeatureTreeBeingEdited = action.payload;
      state.isFeatureTreeBeingSelected = false;
    },
    setIsFeatureTreeBeingSelected: (state, action: PayloadAction<boolean>) => {
      state.isFeatureTreeBeingSelected = action.payload;
      state.isFeatureTreeBeingEdited = false;
    },
    resetFeatureTree: () => ({ ...initialState }),
  },
});

export default featureTreeSlice.reducer;

export const { setIsFeatureTreeBeingEdited, setIsFeatureTreeBeingSelected, resetFeatureTree } =
  featureTreeSlice.actions;
